import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", id: "#home" },
  { label: "Services", id: "#services" },
  { label: "Our Approach", id: "#system" },
  { label: "Work", id: "#work" },
  { label: "About", id: "#about" },
  { label: "Contact", id: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const lenis = useLenis();
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      lenis?.scrollTo(id, { offset: -72 });
    }
  };

  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-2xl"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <button
          data-testid="nav-logo"
          onClick={() => go("#home")}
          className="flex items-center gap-3 text-left transition-opacity duration-300 hover:opacity-80"
          aria-label="The Polemikoi Agency — Home"
        >
          <img src="/assets/logo-mark.png" alt="The Polemikoi Agency" className="h-9 w-auto md:h-10" />
          <span className="hidden font-display text-xs font-extrabold uppercase tracking-[0.25em] text-white sm:block">
            Polemikoi
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l.id)}
              className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-400 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="nav-book-call-btn"
            onClick={() => { setOpen(false); navigate("/book"); }}
            className="hidden bg-white px-5 py-2.5 font-display text-xs font-bold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-crimson hover:text-white sm:block"
          >
            Book a Strategy Call
          </button>
          <button
            data-testid="nav-mobile-menu-btn"
            className="text-white lg:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-black/95 px-6 py-6 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => go(l.id)}
                className="text-left font-display text-lg font-bold uppercase tracking-wide text-zinc-300 transition-colors duration-300 hover:text-white"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-book-call-btn"
              onClick={() => { setOpen(false); navigate("/book"); }}
              className="mt-2 bg-white px-5 py-3 font-display text-sm font-bold uppercase tracking-[0.15em] text-black"
            >
              Book a Strategy Call
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
